<div class="line-bar-chart" *transloco="let t">
  <div style="margin-bottom: 15px" class="flex w-full items-center justify-between pl-5">
    <div class="inline-flex items-center">
      <div class="box-title-sm mr-3">{{ t("sov-main-chart.trend_chart") }}</div>
      <ISwitchButton
        [options]="['bar', 'line']"
        [selected]="isBarChart() ? 'bar' : 'line'"
        [buttonIcons]="['chartColumn', 'chartLine']"
        [buttonTooltips]="['bar', 'line']"
        [type]="SwitchButtonType.ICON"
        (buttonClicked)="changeChartType($event === 'bar')"
      />
    </div>
    <div class="flex">
      @if (dateAggregation(); as dateAggregation) {
        <IDateAggreationSwitchButton
          [selected]="dateAggregation"
          (dateAggSelected)="selectAggregation($event)"
        ></IDateAggreationSwitchButton>
      }
    </div>
  </div>

  @if (!loading()) {
    <IChart [config]="lineChartConfig()" [data]="chartData()" [hoverItem]="hoveredBrand()" />
  } @else {
    <div class="flex h-full items-center justify-center">
      <ISpinner [display]="true" />
    </div>
  }
</div>
